import { useQuery } from '@tanstack/react-query';
import { getDocumentAttachments } from '..';
import { queryKey } from './query-key';

export const useGetDocumentAttachments = (documentId?: number) =>
  useQuery({
    queryKey: queryKey.documentAttachments(documentId!),
    queryFn: () => getDocumentAttachments(documentId!),
    enabled: !!documentId,
  });
